import { SMPContainer } from '../../../index';
import { KnockoutDesktop } from '../Knockout/components/KnockoutDesktop';
import { KnockoutMobile } from '../Knockout/components/KnockoutMobile';
import { useIsSmartphoneDevice } from '../../../../hooks/useIsSmartphoneDevice';
import { INormalizedPlayoffData } from '../../../../types';
import { useRef } from 'react';

export const PlayoffKnockout = ({
  smallFinal,
  groupsEvents,
  roundNames,
  dataLabels,
  handleEventClick,
  sport,
  type,
  isNational,
}: INormalizedPlayoffData): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const maxSteps = roundNames && roundNames.length;
  const { isMobile } = useIsSmartphoneDevice(ref);

  if (roundNames && roundNames.length === 0) {
    return (
      <SMPContainer
        css={{
          paddingBottom: '$3',
          paddingTop: '$3',
          paddingRight: 0,
          paddingLeft: isMobile ? 0 : '$3',
          position: 'relative',
          textAlign: 'center',
          color: '$hiContrast',
        }}
      >
        {dataLabels && dataLabels['no_games']}
      </SMPContainer>
    );
  }

  const hasSmallFinal = Boolean(smallFinal && smallFinal.id);

  return (
    <SMPContainer
      ref={ref}
      style={{ paddingRight: isMobile ? '0' : '$3', paddingLeft: isMobile ? '0' : '$3' }}
      css={{
        paddingBottom: '$3',
        paddingTop: '$3',
        position: 'relative',
        backgroundColor: '$knockoutBgColor',
      }}
    >
      <KnockoutMobile
        isMobile={isMobile}
        maxSteps={maxSteps}
        knockoutGroupGames={groupsEvents}
        knockoutGroupNames={roundNames}
        hasSmallFinal={hasSmallFinal}
        handleEventClick={handleEventClick}
        isPlayoff={true}
        sport={sport}
        type={type}
        isNational={isNational}
      />
      {!isMobile && (
        <KnockoutDesktop
          handleEventClick={handleEventClick}
          knockoutGroupGames={groupsEvents}
          knockoutGroupNames={roundNames}
          hasSmallFinal={hasSmallFinal}
          isPlayoff={true}
          sport={sport}
          type={type}
          isNational={isNational}
        />
      )}
    </SMPContainer>
  );
};
